export default function getOfferPrice({ offer, user }) {
	const { price: defaultPrice } = user?.prices?.[offer.producer?.id]?.[offer.languageRole] || {};

	return offer.price === "default" ? defaultPrice : offer.price;
}
